export const BulkOrderUploadRoute = {
  path: '/loads/bulk-order-upload',
  load: () => import('./BulkOrderUpload'),
  protected: true,
};
